<template>
    <div v-if="items.length" class="announces">
        <div v-for="(item, index) in items" class="toast show" role="alert" aria-live="assertive" aria-atomic="true">
            <div class="container">
                <div class="row">
                    <div class="toast-inner">
                        <a :href="'/events/' + item.slug" class="toast-body">
                            {{  item.name }}
                        </a>
                        <button
                            type="button"
                            class="btn-close btn-close-white"
                            data-bs-dismiss="toast"
                            data-bs-hide="announces"
                            aria-label="Close"
                            @click.prevent="close(item.id)"
                        ></button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default  {
    data() {
        return {
            events: [],
        }
    },
    methods: {
        close(id) {
            this.$cookies.set('event' + id, 1);
            this.events = [...this.events];
        },

    },
    computed: {
        items() {
            return this.events.filter(function(item) {
                return !$cookies.get('event' + item.id);
            });
        },
    },
    mounted: function() {
        axios.get('/ajax/events').then(({data}) => {
            this.events =[
                ...data.data.items
            ];

        }).catch((err) => {
            console.error(err)
        });
    }
}

</script>
